import { SnackbarKey, SnackbarProvider, enqueueSnackbar, useSnackbar } from 'notistack';
import React from 'react';

import { Close } from '@mui/icons-material';
import { IconButton } from '@mui/material';

export const showToast = {
	success: (message: string) => enqueueSnackbar(message, { variant: 'success' }),
	error: (message: string) => enqueueSnackbar(message, { variant: 'error' }),
	warning: (message: string) => enqueueSnackbar(message, { variant: 'warning' }),
	info: (message: string) => enqueueSnackbar(message, { variant: 'info' }),
};

function SnackbarCloseButton({ snackbarKey }: { snackbarKey: SnackbarKey }) {
	const { closeSnackbar } = useSnackbar();

	return (
		<IconButton onClick={() => closeSnackbar(snackbarKey)}>
			<Close sx={{ color: '#FFF' }} />
		</IconButton>
	);
}

function ToastProvider({ children }: { children: JSX.Element }) {
	return (
		<SnackbarProvider
			action={snackbarKey => <SnackbarCloseButton snackbarKey={snackbarKey} />}
			maxSnack={3}
			anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
		>
			{children}
		</SnackbarProvider>
	);
}

export default ToastProvider;
